import {useParams} from "react-router-dom";
import {useQuery} from "react-query";
import {fetchContest, fetchLeaderboard} from "../../api/api";
import {Alert, Table} from "react-bootstrap";
import React from "react";
import {LoadingSpinner} from "./ContestPage";
import {Page} from "../../common/Page";

export const LeaderboardPage = () => {
  const contestId = useParams().contestId || '';

  const {data: contest, isLoading: contestIsLoading, error: contestError} = useQuery(["contests", contestId],
    (_context) => fetchContest({id: contestId}),
    {
      enabled: !!contestId,
      retry: false
    })

  const {
    data: leaderboard,
    isLoading: leaderboardLoading,
    error: leaderboardError
  } = useQuery(["contests", contestId, "leaderboard"],
    (_context) => fetchLeaderboard({contestId}),
    {
      enabled: !!contestId,
      retry: false
    })

  // TODO: build on this component for holding non-loaded state
  if (!contest || !leaderboard) {
    if (contestIsLoading || leaderboardLoading) {
      return <LoadingSpinner/>
    }
    if (contestError || leaderboardError) {
      return <Alert variant="danger">Error occurred</Alert>
    }
    return null;
  }

  return <Page title={"Leaderboard"}
               breadcrumbs={{
                 parents: [{
                   title: "Home",
                   link: "/"
                 },
                   {
                     title: contest?.name,
                     link: `/predictions/contests/${contestId}`
                   }
                 ]
               }}>
    <Table>
      <thead>
      <tr>
        <th>Position</th>
        <th>Name</th>
        <th>Points</th>
      </tr>
      </thead>
      <tbody>
      {leaderboard.leaderboard.map((entry, index) => <tr key={index}>
        <td>{entry.position}</td>
        <td>{entry.participantName}</td>
        <td>{entry.score}</td>
      </tr>)}
      </tbody>
    </Table>
  </Page>
}